import { render, staticRenderFns } from "./InputDescription.vue?vue&type=template&id=274119a3&scoped=true&"
import script from "./InputDescription.vue?vue&type=script&lang=js&"
export * from "./InputDescription.vue?vue&type=script&lang=js&"
import style0 from "./InputDescription.vue?vue&type=style&index=0&id=274119a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274119a3",
  null
  
)

export default component.exports